import { useGetProceduresGroup } from '@vindr/services/actions/procedure.api';
import { filterValidValue } from '@vindr/utils/helpers/common.helper';
import { useDebounce } from '@vindr/utils/hooks/useDebounce';
import useRoleMemo from '@vindr/utils/hooks/useRoleMemo';
import { Select } from 'antd';
import { FormItemProps } from '../templates/FormProps';
import FormSelect from '../templates/FormSelect';

interface ProcedureGroup extends FormItemProps {
  institution_ids?: Parameters<
    typeof useGetProceduresGroup
  >[0]['institution_ids'];
  onChange?: (value: any) => void;
}

const ProcedureGroup = ({
  name = 'procedure_group_id',
  label = 'Procedure Group',
  placeholder = 'Select Procedure Group',
  rules,
  multiple = false,
  required = false,
  institution_ids,
  onChange,
  disabled,
  ...props
}: ProcedureGroup) => {
  const [searchTerm, handleSearch] = useDebounce<string>();
  const { data, isInitialLoading, isRefetching } = useGetProceduresGroup({
    limit: 100,
    offset: 0,
    ...filterValidValue({
      institution_ids,
      name: searchTerm,
    }),
  });
  const procedureGroup = data?.data;

  const rulesMemo = useRoleMemo({ required, rules, disabled });

  return (
    <FormSelect
      {...{ name, label, placeholder, disabled, ...props }}
      {...(multiple && { mode: 'multiple' })}
      loading={isInitialLoading || isRefetching}
      {...(rules || (required && { rules: rulesMemo }))}
      onChange={onChange}
      onSearch={handleSearch}
      showSearch
    >
      {procedureGroup?.map((procedure) => (
        <Select.Option key={procedure.id} value={procedure.code}>
          {procedure.name}
        </Select.Option>
      ))}
    </FormSelect>
  );
};

export default ProcedureGroup;
